import React, { useEffect, useState } from "react";
import { useAtom } from "jotai";
import { DarkModeState } from "../../Jotai/index";
import { Link, useNavigate } from "react-router-dom";
import { me, logout } from "../../lib/api";

export default function AdminHome() {
  const navigate = useNavigate();
  const [authChecked, setAuthChecked] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      const r = await me();
      if (!alive) return;
      if (!r.ok) {
        const redirect = encodeURIComponent("/admin");
        navigate(`/admin/login?redirect=${redirect}`, { replace: true });
      } else {
        setUser(r.user);
        setAuthChecked(true);
      }
    })();
    return () => { alive = false; };
  }, [navigate]);

  const doLogout = async () => {
    try { await logout(); } catch {}
    navigate("/admin/login", { replace: true });
  };
  const [darkMode] = useAtom(DarkModeState);

  if (!authChecked) return null;
  const roles = user?.roles || [];
  const isAdmin = roles.includes("admin");

  const Card = ({ to, title, desc, disabled }) => (
    <Link
      to={disabled ? "#" : to}
      className={`admin-card block rounded-xl border border-neutral-200 bg-white shadow-sm p-5 no-underline transition ${disabled ? "opacity-60 cursor-not-allowed" : "hover:shadow-md hover:-translate-y-1"}`}
      aria-disabled={disabled}
      onClick={e => disabled && e.preventDefault()}
    >
  <h3 className="text-lg font-semibold mb-1">{title}</h3>
      <p className="text-sm text-neutral-700">{desc}</p>
    </Link>
  );

  return (
    <main className={`${darkMode ? "darkmode " : ""}admin-page max-w-5xl mx-auto px-4 py-10`}>
      <header className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold">Admin Dashboard</h1>
          <p className="text-sm text-neutral-600">Signed in as {user?.email}</p>
        </div>
        <button onClick={doLogout} className="px-4 py-2 rounded text-white" style={{ backgroundColor: '#FF9843' }}>Log out</button>
      </header>

      <section className="grid gap-6 sm:grid-cols-2">
        <Card to="/admin/magazines" title="Manage Magazines" desc="Upload, edit, and delete magazine issues." />
        <Card to="/admin/articles" title="Manage Articles" desc="Create and edit website articles." disabled />
        {isAdmin && (
          <Card to="/admin/users" title="Manage Users" desc="Add users, set roles, and reset passwords." />
        )}
      </section>
    </main>
  );
}
